import {pl} from 'date-fns/locale';
import {TimeTrackerResponse} from 'models';
import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
    setCounterValue,
    setSelectedTimeTracker,
    setTimeTrackerInterval,
    startCounter,
    stopCounter,
    timeTrackerSelector,
} from 'store/timeTracker';

export const useTimeTrackerinRedux = () => {
    const dispatch = useDispatch();
    const {timeTrackerInterval} = useSelector(timeTrackerSelector);

    const setTimeTrackerIntervalInRedux = useCallback(
        (interval: NodeJS.Timeout | null) => {
            dispatch(setTimeTrackerInterval(interval));
        },
        [dispatch],
    );
    const startConterInRedux = useCallback(
        (startFrom = 0) => {
            dispatch(setCounterValue(startFrom));
            if (timeTrackerInterval) {
                clearInterval(timeTrackerInterval);
            }
            const interval = setInterval(() => {
                dispatch(startCounter());
            }, 1000);
            setTimeTrackerIntervalInRedux(interval);
        },
        [dispatch, timeTrackerInterval],
    );
    const pauseCounterInRedux = useCallback(() => {
        if (timeTrackerInterval) {
            clearInterval(timeTrackerInterval);
        }
        setTimeTrackerIntervalInRedux(null);
    }, [timeTrackerInterval, setTimeTrackerIntervalInRedux]);
    const playCounterInRedux = useCallback(() => {
        if (!timeTrackerInterval) {
        }

        const interval = setInterval(() => {
            dispatch(startCounter());
        }, 1000);
        setTimeTrackerIntervalInRedux(interval);
    }, [dispatch, timeTrackerInterval, setTimeTrackerIntervalInRedux]);

    const stopCounterInRedux = useCallback(() => {
        dispatch(stopCounter());
    }, [dispatch]);

    const setTimeTrackerEntityInRedux = useCallback(
        (timeTrackerEntity: TimeTrackerResponse | null) => {
            dispatch(setSelectedTimeTracker(timeTrackerEntity));
        },
        [dispatch],
    );

    return {
        startConterInRedux,
        setTimeTrackerIntervalInRedux,
        stopCounterInRedux,
        setTimeTrackerEntityInRedux,
        pauseCounterInRedux,
        playCounterInRedux,
    };
};
